import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GlobalStateContext } from "./GlobalStates";
import MainNavbar from "./mainNavbar";
import PanelBottomNav from "./panelBottomNav";
import {
    APP_TABBAR_MAX_WIDTH,
    applyAppFlavorToDocument,
    persistAppFlavor,
    resolveAppFlavor,
    shouldShowPanelBottomNav,
} from "../helperData/appFlavor";
import { applyWebManifest } from "../helperData/webManifest";

const AppShellNav = () => {
    const location = useLocation();
    const { setCurrentPanel } = useContext(GlobalStateContext);
    const flavor = resolveAppFlavor({
        pathname: location.pathname,
        search: location.search,
    });
    const showPanelNav = shouldShowPanelBottomNav(location.pathname);

    useEffect(() => {
        persistAppFlavor(flavor);
        applyAppFlavorToDocument(flavor);
        applyWebManifest(flavor);
        document.body.classList.toggle("has-app-tabbar", showPanelNav);
        document.body.dataset.appTabbar = showPanelNav ? "on" : "off";
        const isMobileAppShell = window.matchMedia(
            `(max-width: ${APP_TABBAR_MAX_WIDTH}px)`
        ).matches;
        if (showPanelNav && isMobileAppShell) {
            setCurrentPanel(flavor);
        }
    }, [flavor, showPanelNav, setCurrentPanel]);

    if (showPanelNav) {
        return <PanelBottomNav />;
    }
    return <MainNavbar />;
};

export default AppShellNav;
